import { UserFieldErrorMessages } from "@constants/Errors";
import { handleHiraganaKanaChange } from "@services/ErrorHandling";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { TENANTDEPARTMENT } from "@types/tenantDepartment";
import { TextAreaField } from "../../../../components/Inputs/TextAreaField/TextAreaField";

type DepartmentGroupInfoProps = {
  department: TENANTDEPARTMENT;
  errors: [];
  updateError: (field: string, message: string) => void;
  handleInputChange: (field: string, value: string) => void;
};

export const DepartmentGroupInfo = ({
  department,
  errors,
  updateError,
  handleInputChange,
}: DepartmentGroupInfoProps) => {
  return (
    <>
      <div className="mb-4">
        <TextInputField
          label="部署コード"
          type="text"
          placeholder="SHINJUKU01"
          value={department?.display_order}
          required
          onChange={(e) => handleInputChange("display_order", e.target.value)}
        />
      </div>

      <div className="divider"></div>

      <div className="mb-4">
        <TextInputField
          label="部署名"
          type="text"
          placeholder="新宿店"
          value={department?.name}
          required
          onChange={(e) => handleInputChange("name", e.target.value)}
        />
      </div>

      <div className="mb-4">
        <div className="divider" />
        <div className="mb-4 flex flex-col">
          <TextInputField
            label="親部署コード"
            type="text"
            placeholder="SHINJUKU01"
            value={department?.parent_code}
            onChange={(e) => handleInputChange("parent_code", e.target.value)}
          />
        </div>
        <div className="divider"></div>
      </div>

      <div className="mb-4">
        <TextInputField
          label="部署名(ふりがな)"
          type="text"
          placeholder="しんじゅくてん"
          value={department?.name_kana}
          onChange={(e) =>
            handleHiraganaKanaChange(
              "name_kana",
              e.target.value,
              handleInputChange,
              updateError,
            )
          }
        />
        {errors.name_kana && (
          <p className="text-red-500">{UserFieldErrorMessages.nameKanaError}</p>
        )}
      </div>
      <div className="divider" />
      <div className="mb-4 flex flex-col">
        <TextAreaField
          label={"部署概要"}
          value={department?.description}
          onChange={(e) => {
            handleInputChange("description", e.target.value);
          }}
          placeholder={"部署の概要を入力してください。"}
          characterLimit={1000}
        />
      </div>
    </>
  );
};
